export default __webpack_public_path__ + "static/media/dominiquedevos.919cf686.jpg";